import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import styled from '@emotion/styled';

import useAuth from '../../hooks/useAuth';
import { Header } from './header';
import { Nav } from './nav';

export const DashboardLayout = () => {
  const [open, setOpen] = useState(false);

  const { onRefreshScreen } = useAuth();

  useEffect(() => {
    console.log('redering layout');
    onRefreshScreen();
  }, [onRefreshScreen]);

  return (
    <StyledRoot>
      {true ? (
        <>
          <Nav
            open={open}
            toggleNav={() => {
              setOpen(!open);
            }}
          />
          <NonNav>
            <Header navState={open} />
            <Main>
              <Outlet />
            </Main>
          </NonNav>
        </>
      ) : (
        <Navigate to="/account/signin" replace={true} />
      )}
    </StyledRoot>
  );
};

const StyledRoot = styled.div`
  display: flex;
  overflow: hidden;
  height: 100vh;
  /* border: 2px solid blue; */
  background-color: ${({ theme }) => theme.palette.primaryBgColor};
`;

const Main = styled.main`
  flex-direction: column;
  display: flex;
  padding: 1.5rem 2.5rem;
  padding-bottom: 4rem;
  /* border: 2px solid yellow; */

  @media screen and (max-width: 540px) {
    padding: 0 1rem;
  }

  @media screen and (min-width: 1600px) {
    min-width: 1400px;
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const NonNav = styled.section`
  display: flex;
  flex-direction: column;
  overflow: scroll;
  width: 100%;
`;
